import styles from './FooterCellWrapper.module.scss';

import React, { PropsWithChildren } from 'react';

export const FooterCellWrapper: React.FC<PropsWithChildren<unknown>> = (
  props
) => {
  return <div className={styles.wrapper} {...props} />;
};
